import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SuzCredentialsQuery, SuzCredentialsQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SuzCredentialsQuery)
@Wrapper(SuzCredentialsQueryHandlerBase)
export class SuzCredentialsQueryHandler {
    public constructor(
        http: Http
    ) { }
}
